import React, { useEffect, useState } from 'react'
import { COLOR_RED_500, LINEAR_GRADIENT_BG, S3_URL, UN_SELECTED_TAB_TEXT } from '../const'

import { Button, Image, Offcanvas} from "react-bootstrap"
import { MdClose,MdLogout, MdMenu, MdNotificationsPaused, MdOutlineCategory, MdOutlineWidgets, MdSettings, MdWidgets } from 'react-icons/md'
import { useHistory, useLocation } from "react-router-dom";
import { removeCategoryList } from '../redux/reducers/categoryReducer'
import { removeBankList } from '../redux/reducers/bankReducer'
import { removeBrandList } from '../redux/reducers/brandReducer'
import { removePrinter } from '../redux/reducers/printerReducer'
import { useDispatch } from 'react-redux'
import { ReactIcons, MuiIcons } from '../icons'
import _ from 'lodash'
import { GET_ROLE_PERMISSIONS } from '../apollo/rolePermission/query'
import { useLazyQuery } from '@apollo/client'
import { addPermission } from '../redux/reducers/roleReducer'
import { useTranslation } from 'react-i18next';
// import { menuItemsLeft } from './SideBarLeft';

export default function NavBarHeader() {
  const [userData, setUserData] = useState()
  const [openMenu, setOpenMenu] = useState(false)
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const [expandedMenu, setExpandedMenu] = useState(null);
  const [permissions, setPermissions] = useState([])
  const [selectStatus, setSelectStatus] = useState(location.pathname.split("/")[1].split("-")[0]);
  const { t } = useTranslation();

  // apollo client hooks
  const [getRolePermission, { data: rolePermission, loading: loadingRole }] = useLazyQuery(GET_ROLE_PERMISSIONS, { fetchPolicy: "network-only" });

  // useEffect Hooks
  useEffect(() => {
    if (rolePermission && userData?.role !== "ADMIN") {
      const _roles = JSON.parse(rolePermission?.user?.permission?.permissions || [])
      dispatch(addPermission(_roles))
      setPermissions(_roles)
    }
  }, [rolePermission]);

  useEffect(() => {
    let localData = JSON.parse(localStorage.getItem("USER_DATA"))
    if (localData) {
      setUserData(localData?.data)
      fetchPermissionDatas(localData?.data?.id)
    }
  }, [])

  // fetch role and permission
  const fetchPermissionDatas = async (_shopId) => {
    try {
      if (loadingRole) return;
      await getRolePermission({
        variables: {
          where: {
            id: _shopId,
          }
        }
      })

    } catch (error) {
      console.log("error: ", error)
    }
  }

  // handle close menu ....
  const handleClose = () => {
    setOpenMenu(false)
  }

  const toggleMenu = (index) => {
    setExpandedMenu(expandedMenu === index ? null : index);
  };

  // handle select menu patch
  const handleSelectMenu = (item) => {
    switch (item) {
      case "history_menu":
      case "reports_menu":
        return;

      case "investment":
      case "productlist":
      case "sale":
      case "offerpricehistory":
      case "offerprice":
      case "historyproduct":
      case "product_trashed":
      case "sale_invoice":
      case "staff_reports":
      case "order_staff":
      case "orders":
      case "sale_history":
      case "history_offerprices":
        history.push(`/${item}/limit/50/page/1`);
        setSelectStatus(item);
        handleClose();
        break;

      default:
        history.push(`/${item}`);
        setSelectStatus(item);
        handleClose();
        break;
    }
  };

  const getActiveClass = (path) => {
    return location.pathname === path ? 'active' : '';
  }

  // handle logout from system and clear localStorage and data in stata
  const handleLogout = () => {
    localStorage.clear();
    sessionStorage.clear();
    history.push(`/`);
    dispatch(removeCategoryList());
    dispatch(removeBankList());
    dispatch(removeBrandList());
    dispatch(removePrinter());
  }

   const menuItemsLeft = [
    {
      eventKey: "sale",
      icon: MuiIcons.StorefrontRoundedIcon,
      label: "sale_menu",
      divider: false
    },
    {
      isPermission: "CREATE_QUOTAION",
      eventKey: "offerprice",
      icon: MuiIcons.BookmarkAdd,
      label: "offer_price_menu",
      font_size: 22,
      divider: false
    },
    {
      isPermission: "REPORT_STOCK_ALMOST",
      eventKey: "stocknotification",
      icon: ReactIcons.MdCircleNotifications,
      label: "product_almost_menu",
      font_size: 20,
      divider: true
    },
    {
      isPermission: "HISTORY_BILL_SALE",
      eventKey: "history_menu",
      icon: ReactIcons.FaHistory,
      label: "history_menu",
      divider: false,
      font_size: 20,
      menuChild: [
        {
          isPermission: "HISTORY_BILL_SALE",
          eventKey: "sale_history",
          icon: ReactIcons.BsDot,
          label: "sale_history_menu",
          divider: false
        },
        {
          isPermission: "HISTORY_OFFERPRICE_BILL",
          eventKey: "history_offerprices",
          icon: ReactIcons.BsDot,
          label: "offerprice_history_menu",
          divider: false
        },
        {
          isPermission: "HISTORY_INDEBTED_BILL",
          eventKey: "history_indebted",
          icon: ReactIcons.BsDot,
          label: "debt_history_menu",
          divider: false
        },
        {
          isPermission: "HISTORY_UPDATE_STOCK",
          eventKey: "historyproduct",
          icon: ReactIcons.BsDot,
          label: "edit_history_stock_menu",
          divider: false
        },
        {
          isPermission: "HISTORY_DELETED_STOCK",
          eventKey: "product_trashed",
          icon: ReactIcons.BsDot,
          label: "trush_history_menu",
          divider: false
        },
      ]
    },
    {
      isPermission: "REPORT_SALE_ONLY",
      eventKey: "order_staff",
      icon: ReactIcons.FaChartBar,
      font_size: 17,
      label: "order_staff_menu",
      divider: false
    },
    {
      isPermission: "DASHBOARD_SALE",
      eventKey: "reports_menu",
      icon: MuiIcons.BarChartIcon,
      label: "reports_menu",
      divider: true,
      font_size: 20,
      menuChild: [
        {
          isPermission: "DASHBOARD_SALE",
          eventKey: "dashboard",
          icon: ReactIcons.BsDot,
          label: "dashboard_menu",
          divider: false
        },
        {
          isPermission: "HISTORY_BILL_SALE",
          eventKey: "sale_invoice",
          icon: ReactIcons.BsDot,
          label: "report_bill_menu",
          divider: false
        },
        {
          isPermission: "DASHBOARD_SALE",
          eventKey: "sale_categories",
          icon: ReactIcons.BsDot,
          label: "report_category_menu",
          divider: false
        },
      ]
    },
    {
      isPermission: "CREATE_INCOME_STOCK",
      eventKey: "purchase_management",
      icon: ReactIcons.AiFillTag,
      font_size: 20,
      label: "improted_stock_menu",
      divider: false
    },
    {
      isPermission: "STOCK_MANAGEMENTS",
      eventKey: "productlist",
      icon: MuiIcons.WarehouseIcon,
      font_size: 20,
      label: "stock_menu",
      divider: false
    },
    {
      isPermission: "INVENTORY_MANAGEMENTS",
      eventKey: "inventory",
      icon: MuiIcons.InventoryIcon,
      font_size: 20,
      label: "inventory_menu",
      divider: false
    },
    {
      isPermission: "SETTING_MANAGEMENT",
      eventKey: "settings",
      icon: MuiIcons.SettingsIcon,
      label: "setting_menu",
      divider: true
    },
  
  ];

  // check role admin
  const isAdmin = userData?.role === "ADMIN";

  return (
    <>
      <header style={{ position: 'fixed', display: 'flex', justifyContent: 'space-between', left: 0, top: 0, zIndex: 9999, width: '100%', background: LINEAR_GRADIENT_BG }}>
        <Button onClick={() => setOpenMenu(!openMenu)} variant='light' style={{ background: 'none' }}>
          {openMenu ? <MdClose style={{ fontSize: 28, color: "#fff" }} /> : <MdMenu style={{ fontSize: 28, color: "#fff" }} />}
        </Button>
        <div className='d-flex gap-2 justify-content-end align-items-center'>
          <p style={{ fontSize: 14 }}>{userData?.firstName} {userData?.lastName}</p>
          <Image src={S3_URL + userData?.shop?.image} roundedCircle style={{ width: 40, height: 40, background: "#fff" }} />
        </div>
      </header>

      <Offcanvas show={openMenu} onHide={handleClose} style={{ maxWidth: 260 }}>
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Offcanvas</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body style={{ overflowY: 'auto', padding: '4px 0' }}>
          {isAdmin ? (
            <ul>
              {menuItemsLeft?.map((item, index) => (
                  <React.Fragment key={index}>
                    <li
                      className={`menu-mobile-side ${getActiveClass(item.eventKey)}`} // Add active class based on the current path
                      onClick={() => {
                        handleSelectMenu(item?.eventKey);
                        toggleMenu(index);
                      }}
                      style={{ color: selectStatus === item?.eventKey ? COLOR_RED_500 : UN_SELECTED_TAB_TEXT }}
                    >
                      <span>
                        <item.icon style={{ fontSize: 20, color: "#777" }} /> &nbsp; {t(item?.label)}
                      </span>
                      {!_.isEmpty(item?.menuChild) && <ReactIcons.MdKeyboardArrowRight />}
                    </li>

                    {/* menu child */}
                    {item?.menuChild && expandedMenu === index && (
                      <ul>
                        {item.menuChild?.map((child, childIndex) => (
                            <li
                              key={childIndex}
                              className={`menu-mobile-side ${getActiveClass(child.eventKey)}`} // Add active class based on the current path
                              onClick={() => handleSelectMenu(child?.eventKey)}
                              style={{ color: selectStatus === child?.eventKey ? COLOR_RED_500 : UN_SELECTED_TAB_TEXT }}
                            >
                              <span>
                                <child.icon style={{ fontSize: 20, color: "#777" }} /> &nbsp; {t(child?.label)}
                              </span>
                            </li>
                          ))}
                      </ul>
                    )}
                  </React.Fragment>
                ))}
              <li className='menu-logout-side' onClick={handleLogout}>
                <MdLogout style={{ fontSize: 24 }} /> &nbsp; ອອກຈາກລະບົບ
              </li>
            </ul>
          ) : (
            <ul>
              {menuItemsLeft?.filter(item => !item.isPermission || permissions.includes(item?.isPermission))
                .map((item, index) => (
                  <React.Fragment key={index}>
                    <li
                      className={`menu-mobile-side ${getActiveClass(item.eventKey)}`} // Add active class based on the current path
                      onClick={() => {
                        handleSelectMenu(item?.eventKey);
                        toggleMenu(index);
                      }}
                      style={{ color: selectStatus === item?.eventKey ? COLOR_RED_500 : UN_SELECTED_TAB_TEXT }}
                    >
                      <span>
                        <item.icon style={{ fontSize: 20, color: "#777" }} /> &nbsp; {t(item?.label)}
                      </span>
                      {!_.isEmpty(item?.menuChild) && <ReactIcons.MdKeyboardArrowRight />}
                    </li>

                    {/* menu child */}
                    {item?.menuChild && expandedMenu === index && (
                      <ul>
                        {item.menuChild
                          .filter(childItem => !childItem.isPermission || permissions.includes(childItem?.isPermission)) // Filter based on permissions
                          .map((child, childIndex) => (
                            <li
                              key={childIndex}
                              className={`menu-mobile-side ${getActiveClass(child.eventKey)}`} // Add active class based on the current path
                              onClick={() => handleSelectMenu(child?.eventKey)}
                              style={{ color: selectStatus === child?.eventKey ? COLOR_RED_500 : UN_SELECTED_TAB_TEXT }}
                            >
                              <span>
                                <child.icon style={{ fontSize: 20, color: "#777" }} /> &nbsp; {t(child?.label)}
                              </span>
                            </li>
                          ))}
                      </ul>
                    )}
                  </React.Fragment>
                ))}
              <li className='menu-logout-side' onClick={handleLogout}>
                <MdLogout style={{ fontSize: 24 }} /> &nbsp; ອອກຈາກລະບົບ
              </li>
            </ul>
          )}

        </Offcanvas.Body>
      </Offcanvas>
    </>
  )
}
 